import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import {  toast } from 'react-toastify';
import config from '../Config/Config';

function HideOnScroll(props) {

    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
    });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default function NavBar(props) {
    const { color, setColor} = props;
    let navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [userData, setUserData] = useState({});
    // console.log(token);

    const darkTheme = createTheme({
        palette: {
            mode: `${color}`,
            primary: {
                main: '#D6FE7A',
            },
        },
    });

    function userName(){
        try{
            fetch(config.apiUrlprofile,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
              }

        })
        .then(res=> res.json())
        .then(data=> {console.log(data)
            localStorage.setItem("id", data._id);
        setUserData(data)})
        }
        catch{
            console.log("error occured");
        }
    }
        useEffect(() => {
            userName();
        }, [token])

    function Logout() {
        localStorage.clear();
        navigate('/');
        toast('User Logged out', {
            position: "top-center",
            autoClose: 1000,
            type: "success",
            theme:"colored",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            })
    }

    function themeChange(){
        if(color=='dark'){
            setColor('light');
            document.body.style.backgroundColor= 'white';
        }else if(color=='light'){
            setColor('dark');
            document.body.style.backgroundColor= 'black';
        }
    }
    return (
        <div className='container'>
            <Box sx={{ flexGrow: 1 }}>
                <ThemeProvider theme={darkTheme}>
                    <HideOnScroll>

                        <AppBar >
                            <Toolbar>
                                <Typography onClick={() => navigate('/')} variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                    CRYPTO WATCHER
                                </Typography>                                
                                <div className='justify-content-center'>
                                    {
                                        token == null ? <div>
                                            <Button onClick={() => navigate('/about')} className='mx-1' color="inherit">ABOUT</Button>
                                            <Button onClick={() => navigate('/contact')} className='mx-1' color="inherit">CONTACT</Button>
                                            <Button onClick={() => navigate('/login')} className='mx-1' color="inherit">LOGIN</Button>
                                        </div> : <div>
                                            <div className="dropdown">
                                                <button className={`btn btn-${color} dropdown-toggle`} type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="fa-solid fa-user"></i> {userData.firstname} {userData.lastname}
                                                </button>
                                                <ul className={`dropdown-menu dropdown-menu-${color}`} aria-labelledby="dropdownMenuButton2">
                                                    <li><Button onClick={() => navigate('/home')} className='mx-1' color="inherit">HOME</Button></li>
                                                    <li><Button onClick={() => navigate('/about')} className='mx-1' color="inherit">ABOUT</Button></li>
                                                    <li><Button className='mx-1' onClick={() => navigate('/contact')} color="inherit">CONTACT US</Button></li>
                                                    <li><Button className='mx-1' onClick={() => navigate('/profile')} color="inherit">PROFILE</Button></li>
                                                    <li><Button className='mx-1' onClick={() => navigate('/fav')} color="inherit">FAVORITES</Button></li>
                                                    <li><Button onClick={Logout} className='mx-1' color="inherit">LOGOUT</Button></li>
                                                </ul>
                                            </div>
                                            
                                            
                                            
                                            

                                            
                                        </div>
                                    }

                                </div>
                                <div>
                                    {
                                        color=='dark'?<i title='Light Mode' onClick={themeChange} className="fa-solid fa-sun mx-3"></i>: <i title='Dark Mode' className="fa-solid fa-moon mx-3" onClick={themeChange}></i>
                                    }
                                
                                </div>

                            </Toolbar>
                        </AppBar>

                    </HideOnScroll>
                </ThemeProvider>
            </Box>
        </div>
    )
}
